<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 py-5">
      <v-slide-x-transition>
        <v-img
          :src="require('@/assets/images/public/logo.png')"
          max-height="100px"
          max-width="150px"
          alt="logo"
          contain
        ></v-img>
      </v-slide-x-transition>
    </div>

    <!-- Navigation Items -->
    <v-list expand class="vertical-nav-menu pl-1 pr-5">
      <template v-for="(item, index) in navLink" v-if="item.show">
        <nav-menu-group
          v-if="item.child && item.child.length"
          :title="item.title"
           :key="`${index}_${item.title}`"
          :icon="item.icon"
          :isSvgIcon="item.isSvgIcon"
        >
          <nav-menu-link
            v-for="(subItem, linkIndex) in item.child"
            v-if="subItem.show"
            :key="`link_${item.title}_${linkIndex}`"
            :title="subItem.title"
            :to="subItem.route"
            :icon="subItem.icon"
            :isSvgIcon="subItem.isSvgIcon"
          />
        </nav-menu-group>
        <nav-menu-link
          v-else
          :key="`item_${item.title}_${index}`"
          :title="item.title"
          :to="item.route"
          :icon="item.icon"
          :isSvgIcon="item.isSvgIcon"
        />
      </template>

      <label class="text-caption px-4 mt-5 d-block colorGrey--text font-weight-black" v-if="userType === 'developer'">開發人員</label>
      <template v-for="(item, index) in devNavLink" v-if="item.show && userType === 'developer'">
        <nav-menu-group
          v-if="item.child && item.child.length"
          :title="item.title"
          :key="`${index}_${item.title}`"
          :icon="item.icon"
          :isSvgIcon="item.isSvgIcon"
        >
          <nav-menu-link
            v-for="(subItem, linkIndex) in item.child"
            v-if="subItem.show"
            :key="`link_${item.title}_${linkIndex}`"
            :title="subItem.title"
            :to="subItem.route"
            :icon="subItem.icon"
            :isSvgIcon="subItem.isSvgIcon"
          />
        </nav-menu-group>
        <nav-menu-link
          v-else
          :key="`item_${item.title}_${index}`"
          :title="item.title"
          :to="item.route"
          :icon="item.icon"
          :isSvgIcon="item.isSvgIcon"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import NavMenuLink from './components/NavMenuLink.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import { cannotAccessList } from '@/assets/cannotAccessList'
import {
  mdiEmoticonOutline,
  mdiEmailOutline,
  mdiPostOutline,
  mdiCommentQuestionOutline,
  mdiCogOutline,
  mdiCartOutline
} from '@mdi/js'

export default {
  components: {
    NavMenuLink,
    NavMenuGroup,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiEmoticonOutline,
        mdiEmailOutline,
        mdiPostOutline,
        mdiCommentQuestionOutline,
        mdiCogOutline,
        mdiCartOutline,
      },
    }
  },
  data: () => ({
    navLink: [],
    devNavLink: [],
    userType: '',
  }),
  methods: {
    initializeNavLink() {
      this.navLink = [
        {
          title: 'menu.user',
          route: { name: 'UserList' },
          icon: this.icons.mdiEmoticonOutline,
          show: !cannotAccessList['UserList'] || !cannotAccessList['UserList'].includes(this.userType),
        },
        {
          title: 'menu.order',
          route: { name: 'OrderList' },
          icon: 'menuOrder',
          isSvgIcon: true,
          show: !cannotAccessList['OrderList'] || !cannotAccessList['OrderList'].includes(this.userType),
        },
         {
          title: 'menu.customerNewService',
          route: { name: 'AppliedServiceList' },
          icon: 'menuService',
          isSvgIcon: true,
          show: !cannotAccessList['AppliedServiceList'] || !cannotAccessList['AppliedServiceList'].includes(this.userType),
        },
        {
          title: 'menu.letterAndPackage',
          route: { name: 'LetterPackageList' },
          icon: this.icons.mdiEmailOutline,
          show:
            !cannotAccessList['LetterPackageList'] || !cannotAccessList['LetterPackageList'].includes(this.userType),
        },
        {
          title: 'menu.blog',
          route: { name: 'BlogList' },
          icon: this.icons.mdiPostOutline,
          show: !cannotAccessList['BlogList'] || !cannotAccessList['BlogList'].includes(this.userType),
        },
        {
          title: 'menu.faq',
          route: { name: 'FaqList' },
          icon: 'menuFaq',
          isSvgIcon: true,
          show: !cannotAccessList['FaqList'] || !cannotAccessList['FaqList'].includes(this.userType),
        },
        {
          title: 'menu.enquiry',
          route: { name: 'EnquiryList' },
          icon: 'menuEnquiry',
          isSvgIcon: true,
          show: !cannotAccessList['EnquiryList'] || !cannotAccessList['EnquiryList'].includes(this.userType),
        },
        {
          title: 'menu.setting',
          route: { name: 'Setting' },
          icon: this.icons.mdiCogOutline,
          show: !cannotAccessList['Setting'] || !cannotAccessList['Setting'].includes(this.userType),
        },
      ]

      this.devNavLink = [
        {
          title: 'menu.plan',
          route: { name: 'PlanList' },
          icon: this.icons.mdiCogOutline,
          show: !cannotAccessList['PlanList'] || !cannotAccessList['PlanList'].includes(this.userType),
        },
        {
          title: 'menu.addon',
          route: { name: 'AddonList' },
          icon: this.icons.mdiCartOutline,
          show: !cannotAccessList['AddonList'] || !cannotAccessList['AddonList'].includes(this.userType),
        },
      ]
    },
  },
  async created() {
    this.userType = this.getUserType()
    this.initializeNavLink()
  },
}
</script>

<style>
.v-navigation-drawer__content {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  max-height: 100%;
}
</style>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  background-color: #fafafa !important;

  .v-list {
    flex: 1 !important;

    .v-list-item {
      &.vertical-nav-menu-link {
        border-radius: 5px;

        &::before {
          display: none;
        }

        ::v-deep .v-list-item__icon {
          .v-icon {
            transition: none !important;
          }
        }
      }
    }
  }
}

.vertical-nav-menu {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
}

.v-application.theme--dark .app-navigation-menu {
  background-color: #272727 !important;
}
</style>
